import { mergeOccupants } from 'lib/offer/occupancyUtils'

export function sumOccupancies(
  occupancies: Array<App.Occupants | undefined>,
): App.Occupants | undefined {
  const validOccupancies = occupancies.filter((occupancy): occupancy is App.Occupants => Boolean(occupancy))

  if (validOccupancies.length === 0) {
    return undefined
  }

  return mergeOccupants(validOccupancies)
}
